import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

Vue.config.devtools = window.location.origin !== 'https://muzikdreamer.com';
Vue.config.productionTip = false;

import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import VueMeta from 'vue-meta';

Vue.use(VueMeta, {
  // optional pluginOptions
  keyName: 'metaInfo',
  refreshOnceOnNavigation: true,
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
